import type { ReactNode } from 'react';

import styles from './Card.module.css';

export interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return <section className={`${styles.card} ${className ?? ''}`}>{children}</section>;
}

export interface CardHeadProps {
  index?: string;
  title: ReactNode;
  hint?: ReactNode;
  actions?: ReactNode;
}

export function CardHead({ index, title, hint, actions }: CardHeadProps) {
  return (
    <header className={styles.head}>
      <div className={styles.headTitle}>
        {index && <span className={styles.headIndex}>{index}</span>}
        <h2 className={styles.title}>{title}</h2>
        {hint && <span className={styles.hint}>{hint}</span>}
      </div>
      {actions}
    </header>
  );
}

export interface CardBodyProps {
  children: ReactNode;
  pad?: boolean;
  className?: string;
}

export function CardBody({ children, pad, className }: CardBodyProps) {
  return (
    <div className={`${styles.body} ${pad ? styles.pad : ''} ${className ?? ''}`}>
      {children}
    </div>
  );
}
